import { values } from './enums'

const SnapshotDateQuarterly = {
  FROM_START: 0,
  TILL_END: 1,
  PAST_END: 2
}

const VALUES = values(SnapshotDateQuarterly)

export {
  SnapshotDateQuarterly,
  VALUES
}



// WEBPACK FOOTER //
// ./src/enums/SnapshotDateQuarterly.js